<template lang="html">
  <div class="main">
    <button type="button" class="measure-button" @click="measure()">등가소음 재기 </button>

    <div class="chartWrap">
      <canvas id="myAverChart" width="800" height="400"></canvas>
    </div>

    <div class="select-last">
      최근 {{showNum}}개를 차트로 불러왔습니다.
      <div class="show-button">
        <button type="button" name="button" @click="changeShow(30)">최근 30개</button>
      </div>
      <div class="show-button">
        <button type="button" name="button" @click="changeShow(60)">최근 60개</button>
      </div>
      <div class="show-button">
        <button type="button" name="button" @click="changeShow(90)">최근 90개</button>
      </div>
      <div class="show-button">
        입력: <input type="text" name="button" v-model = "showNum" @click="changeShow(showNum)" placeholder="보고싶은 개수를 입력하세요"></input>
      </div>
    </div>

    <div class="show-button">
      <button type="button" @click="changeState()">{{show? "데이터 감추기":"데이터 보이기"}}</button>
    </div>

    <div class="show-data-wrap" v-if="show">
      <div class="show-data" :key="i" v-for="(data,i) in datas">
        시간: {{data.time}}<br> 평균: {{data.sound}}
      </div>
    </div>

  </div>
</template>

<script>
import firebase from '../Firebase'
export default {
  data() {
    return {
      datas: [],
      myChart: -1,
      show: true,
      showNum: 0
    }
  },
  created() {
    firebase.database().ref('/noise/id/1/checklist')
    .on('child_added',(el)=> {
      this.datas.push({'sound': el.child('average').val(), 'time': el.child('time').val()});
      this.showNum = this.datas.length;
    });
  },
  mounted() {
    this.$nextTick( () =>
      this.drawChart(this.showNum)
    )
  },
  updated() {
    if(this.myChart == -1){
        this.drawChart(this.showNum);
    }else{
      this.myChart.destroy();
      this.drawChart(this.showNum);
    }
  },
  methods: {
    changeState() {
      this.show = !this.show;
    },
    measure() {
      firebase.database().ref('/noise/id/1/check')
      .push({
        "check": true,
      })
      console.log("measure Start");
      alert("측정을 시작했습니다.");
    },
    drawChart(el){
      //console.log(this.datas.map( el => { return {x: moment(el.date,'MMMM Do YYYY, h:mm:ss a').valueOf(), y: el.vib }}));
      var ctx = document.getElementById('myAverChart').getContext('2d');
      this.myChart = new Chart(ctx,{
         type: 'bar',
         data: {
          datasets: [{
             label: '등가 소음도',
             data: this.datas.map( el => { return {x: el.time, y: el.sound }}).slice(this.datas.length - el, this.datas.length),
             backgroundColor: 'rgba(192,192,0,0.5)',
             borderColor: 'rgb(210, 0, 72)',
             pointRadius: 0,
             fill: true,
             lineTension:  1,
             borderWidth: 2
          }]
         },
         options: {
           responsive: true,
            scales: {
               xAxes: [{
                  type: 'time',
                  distribution: 'series',
                  ticks: {
                     source: 'data',
                     autoSkip: false,
                  }
               }],
               yAxes: [{
                  id: 'A',
                  type: 'linear',
                  position: 'left',
                },
              ]
            },
            tooltips: {
               intersect: false,
               mode: 'index',
               callbacks: {
                  label: function(tooltipItem, myData) {
                     var label = myData.datasets[tooltipItem.datasetIndex].label || '';
                     if (label) {
                        label += ': ';
                     }
                     label += parseFloat(tooltipItem.value).toFixed(2);
                     return label;
                  }
               }
            },
            // annotation: {
            //   annotations: [{
            //     type: 'line',
            //     mode: 'horizontal',
            //     scaleID: 'A',
            //     value: 1000,
            //     borderColor: 'rgb(75, 192, 192)',
            //     borderWidth: 5,
            //     label: {
            //       enabled: false,
            //       content: 'Test label'
            //     }
            //   }]
            // },
          }
      });
    },
    changeShow(el) {
      console.log(el);
      if(el <= this.datas.length){
          this.showNum = el;
      }else{
        this.showNum = this.datas.length;
        alert("데이터 수가 더 적어요!")
      }
    },
  }
}
</script>

<style scoped>
.show-button{
  margin: 10px 0;
}
.measure-button{
  padding: 10px 20px;
  border: solid 1px black;
  box-sizing: border-box;
}
.show-button button{
  width: 200px;
  height: 30px;
  background-color: white;
  color: black;
  border: 1px solid black;
  border-radius: 2px;
}
.show-data{
  width: 400px;
  border: 1px solid black;
  border-radius: 3px;
  padding: 5px 0;
  display: inline-block;
  margin-bottom: 8px;

}
</style>



// WEBPACK FOOTER //
// src/components/NoiseAverage.vue